export const checkBlockAspectFitsWhitelist = (whiteListedAspects = [], { aspect }) =>
  whiteListedAspects.includes(aspect)

export function getComponentOrClassNameByGeoentityBlockAspect(aspectToClassNameOrComponent, { aspect, type }) {
  const whiteListedAspects = Object.keys(aspectToClassNameOrComponent)

  if (!checkBlockAspectFitsWhitelist(whiteListedAspects, { aspect, type })) return null

  return aspectToClassNameOrComponent[aspect]
}
